import React, { useEffect, useState } from "react";
import "./contactUs.scss";
import { Button, Grid, Stack, TextField, useMediaQuery } from "@mui/material";
import brandStore from "../../store/brandStore";
import authStore from "../../store/authStore";
import contactUsStore from "../../store/contactUsStore";
import snackbarStore from "../../store/snackbarStore";
import SnackbarAlert from "../../components/snackbarAlert/snackbarAlert";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
// Icons
import PhoneRoundedIcon from "@mui/icons-material/PhoneRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import PlaceRoundedIcon from "@mui/icons-material/PlaceRounded";

import { FaFacebookF, FaYoutube, FaInstagram } from "react-icons/fa";

// Images
import contact_us_img from "../../assets/img/contact-us.webp";
import { LoadingButton } from "@mui/lab";
import SEO from "components/seo/SEO";

const ContactUs = () => {
  const maxWidth400 = useMediaQuery("(max-width: 400px)");
  const BrandStore = brandStore();
  const AuthStore = authStore();
  const ContactUsStore = contactUsStore();
  const SnackbarStore = snackbarStore();

  const [sendMessageLoading, setSendMessageLoading] = useState();

  const AutoFillDetails = () => {
    if (AuthStore.isLogged) {
      ContactUsStore.setContactUsFormIsLoggedIn({
        firstName: AuthStore.myUser.firstName,
        lastName: AuthStore.myUser.lastName,
        email: AuthStore.myUser.email,
        phoneNo: AuthStore.myUser.phoneNumber,
      });
    }
  };

  const checkValidation = () => {
    let flag = true;
    if (ContactUsStore.contactUsForm.firstName === "") {
      flag = false;
      ContactUsStore.setContactUsFormIsError({
        name: "firstName",
        value: true,
      });
    } else {
      ContactUsStore.setContactUsFormIsError({
        name: "firstName",
        value: false,
      });
    }

    if (ContactUsStore.contactUsForm.lastName === "") {
      flag = false;
      ContactUsStore.setContactUsFormIsError({
        name: "lastName",
        value: true,
      });
    } else {
      ContactUsStore.setContactUsFormIsError({
        name: "lastName",
        value: false,
      });
    }

    if (ContactUsStore.contactUsForm.email === "") {
      flag = false;
      ContactUsStore.setContactUsFormIsError({
        name: "emailMessage",
        value: "Email is require",
      });
      ContactUsStore.setContactUsFormIsError({
        name: "email",
        value: true,
      });
    } else {
      const reg = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (reg.test(ContactUsStore.contactUsForm.email) === true) {
        ContactUsStore.setContactUsFormIsError({
          name: "email",
          value: false,
        });
      } else {
        flag = false;
        ContactUsStore.setContactUsFormIsError({
          name: "emailMessage",
          value: "Email is invalid",
        });
        ContactUsStore.setContactUsFormIsError({
          name: "email",
          value: true,
        });
      }
    }

    if (ContactUsStore.contactUsForm.phoneNo === "") {
      flag = false;
      ContactUsStore.setContactUsFormIsError({
        name: "phoneNo",
        value: true,
      });
    } else {
      ContactUsStore.setContactUsFormIsError({
        name: "phoneNo",
        value: false,
      });
    }

    if (ContactUsStore.contactUsForm.message === "") {
      flag = false;
      ContactUsStore.setContactUsFormIsError({
        name: "message",
        value: true,
      });
    } else {
      ContactUsStore.setContactUsFormIsError({
        name: "message",
        value: false,
      });
    }

    return flag;
  };

  const sendContactUsMessage = async () => {
    const isValid = checkValidation();

    if (isValid) {
      setSendMessageLoading(true);
      const res = await ContactUsStore.createContactUs();

      if (res) {
        SnackbarStore.setMassage({ value: "Successfully Send" });
        SnackbarStore.setIsOpen({ value: true });
      }
      setSendMessageLoading(false);
    }
  };

  return (
    <div className="contact-us">
      <SEO
        title="Contact Us | KRISTIVE"
        description="Need help or have questions? Reach out to us through our contact form, email, or phone. Our team is always happy to assist you."
      />
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        alertVariant="filled"
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        massage={SnackbarStore.massage}
      />
      <h1 className="head-title">Contact Us</h1>
      <div className="head-sub-title">
        Any question or remarks? Just write us a message!
      </div>
      <div className="main-content">
        <Grid container>
          <Grid item xs={12} sm={12} md={4} lg={4}>
            <div
              className="contact-info"
              style={{
                backgroundImage: `url(${contact_us_img})`,
              }}
            >
              <div>
                <Stack spacing={2}>
                  <h2 className="contact-info-title">Contact Information</h2>
                  <div className="contact-info-sub-desc">
                    Fill up the form and our Team will get back to you within 24
                    hours.
                  </div>
                </Stack>
                <Stack
                  spacing={3}
                  sx={{
                    mt: 5,
                  }}
                  className="basic-info-brand"
                >
                  {BrandStore.brand.brandContactUs && (
                    <Stack spacing={1} direction="row" className="item">
                      <PhoneRoundedIcon />
                      <p>{BrandStore.brand.brandContactUs}</p>
                    </Stack>
                  )}

                  <Stack spacing={1} direction="row" className="item">
                    <EmailRoundedIcon />
                    <p>{BrandStore.brand.brandEmail}</p>
                  </Stack>
                  <Stack spacing={1} direction="row" className="item">
                    <PlaceRoundedIcon />
                    <p>{BrandStore.brand.brandAddress}</p>
                  </Stack>
                </Stack>
              </div>
              <Stack spacing={2} direction="row">
                <div className="social-item">
                  <FaInstagram
                    className="social-icon"
                    onClick={() =>
                      window.open("https://www.instagram.com/kristiveofficial/")
                    }
                  />
                </div>
                {/* <div className="social-item">
                  <FaFacebookF
                    className="social-icon"
                    onClick={() => window.open("https://www.facebook.com/")}
                  />
                </div>
                <div className="social-item">
                  <FaYoutube
                    className="social-icon"
                    onClick={() => window.open("https://youtube.com/")}
                  />
                </div> */}
              </Stack>
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={8} lg={8}>
            <div className="contact-form">
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    required
                    fullWidth
                    variant="standard"
                    name="firstName"
                    label="First Name"
                    autoComplete="given-name"
                    type="text"
                    value={ContactUsStore.contactUsForm.firstName}
                    onChange={ContactUsStore.setContactUsForm}
                    error={ContactUsStore.contactUsFormIsError.firstName}
                    helperText={
                      ContactUsStore.contactUsFormIsError.firstName &&
                      "First Name is require"
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    required
                    fullWidth
                    variant="standard"
                    name="lastName"
                    label="Last Name"
                    autoComplete="family-name"
                    type="text"
                    value={ContactUsStore.contactUsForm.lastName}
                    onChange={ContactUsStore.setContactUsForm}
                    error={ContactUsStore.contactUsFormIsError.lastName}
                    helperText={
                      ContactUsStore.contactUsFormIsError.lastName &&
                      "Last Name is require"
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    required
                    fullWidth
                    variant="standard"
                    name="email"
                    label="Email"
                    autoComplete="email"
                    type="email"
                    value={ContactUsStore.contactUsForm.email}
                    onChange={ContactUsStore.setContactUsForm}
                    error={ContactUsStore.contactUsFormIsError.email}
                    helperText={
                      ContactUsStore.contactUsFormIsError.email &&
                      ContactUsStore.contactUsFormIsError.emailMessage
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    name="phoneNo"
                    inputProps={{ inputMode: "numeric", maxLength: 10 }}
                    required
                    fullWidth
                    label="Phone No"
                    autoComplete="phone"
                    variant="standard"
                    type="text"
                    value={ContactUsStore.contactUsForm.phoneNo}
                    onChange={ContactUsStore.setContactUsForm}
                    error={ContactUsStore.contactUsFormIsError.phoneNo}
                    helperText={
                      ContactUsStore.contactUsFormIsError.phoneNo &&
                      "Phone No is require"
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <TextField
                    name="message"
                    required
                    fullWidth
                    label="Massage"
                    variant="standard"
                    type="text"
                    multiline
                    rows={4}
                    placeholder="Write your message..."
                    focused
                    value={ContactUsStore.contactUsForm.message}
                    onChange={ContactUsStore.setContactUsForm}
                    error={ContactUsStore.contactUsFormIsError.message}
                    helperText={
                      ContactUsStore.contactUsFormIsError.message &&
                      "Message is require"
                    }
                  />
                </Grid>
              </Grid>
              <div
                className="btn-container"
                style={{
                  flexDirection: maxWidth400 ? "column" : "row",
                  justifyContent: AuthStore.isLogged && "space-between",
                }}
              >
                {AuthStore.isLogged && (
                  <Button
                    onClick={AutoFillDetails}
                    className="auto-fill-btn"
                    color="info"
                  >
                    Auto Fill Your Details
                  </Button>
                )}
                <LoadingButton
                  className="btn"
                  variant="contained"
                  style={{
                    background: sendMessageLoading && "#f5f5f5",
                    marginTop: maxWidth400 && "10px",
                  }}
                  onClick={sendContactUsMessage}
                  loading={sendMessageLoading}
                  startIcon={<EditRoundedIcon />}
                >
                  <p>Send Message</p>
                </LoadingButton>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ContactUs;
